<!-- ModalHeader.vue - исправленный -->
<template>
  <div>
    <!-- Кнопка назад для первого экрана (ведет к someMethod/scroll-back) -->
    <div class="back_arrow_v2" @click="$emit('scroll-back')" v-if="isFirstScreen">
      <svg width="39" height="15" viewBox="0 0 39 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.292892 8.07106C-0.0976295 7.68054 -0.0976295 7.04737 0.292892 6.65685L6.65685 0.292885C7.04738 -0.0976396 7.68054 -0.0976396 8.07107 0.292885C8.46159 0.683409 8.46159 1.31657 8.07107 1.7071L2.41422 7.36395L8.07107 13.0208C8.46159 13.4113 8.46159 14.0445 8.07107 14.435C7.68054 14.8255 7.04738 14.8255 6.65685 14.435L0.292892 8.07106ZM39 7.36395V8.36395H1V7.36395V6.36395H39V7.36395Z"
          fill="#8A75FF" />
      </svg>
    </div>

    <!-- Кнопка назад для остальных экранов (ведет к TemporalyBack) -->
    <div class="back_arrow" @click="$emit('back')" v-else-if="!isFirstScreen">
      <svg width="39" height="15" viewBox="0 0 39 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.292892 8.07106C-0.0976295 7.68054 -0.0976295 7.04737 0.292892 6.65685L6.65685 0.292885C7.04738 -0.0976396 7.68054 -0.0976396 8.07107 0.292885C8.46159 0.683409 8.46159 1.31657 8.07107 1.7071L2.41422 7.36395L8.07107 13.0208C8.46159 13.4113 8.46159 14.0445 8.07107 14.435C7.68054 14.8255 7.04738 14.8255 6.65685 14.435L0.292892 8.07106ZM39 7.36395V8.36395H1V7.36395V6.36395H39V7.36395Z"
          fill="#8A75FF" />
      </svg>
    </div>

    <!-- Заголовок с правильными отступами -->
    <div class="modal_head" v-if="!isFirstScreen">
      Аудит регламента
    </div>

    <!-- Прогресс-бар -->
    <div class="modal_flow" v-if="!isFirstScreen" :key="flowKey">
      <div class="modal_flow_element" v-for="(f, index) in flow" :key="index" v-if="index !== 0">
        <div class="modal_flow_element_num" v-if="!f.complite"
          :class="{ 
            num_active: f.active,
            num_errore: f.errore 
          }" 
          @click="$emit('flow-click', f.num)">
          {{ f.num }}
        </div>
        <div class="modal_flow_element_num" v-if="f.complite" :class="{ num_complite: f.complite }">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"
              fill="white" />
          </svg>
        </div>
        <div v-if="text == 'ru'" class="modal_flow_element_text">
          {{ f.textRU }}
        </div>
        <div v-if="text == 'en'" class="modal_flow_element_text">
          {{ f.textEN }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalHeader',
  props: {
    isFirstScreen: {
      type: Boolean,
      default: false
    },
    flow: {
      type: Array,
      required: true
    },
    text: {
      type: String,
      default: 'ru'
    }
  },
  computed: {
    flowKey() {
      return this.flow.map(f => `${f.num}-${f.active}-${f.complite}`).join('|')
    }
  }
}
</script>

<style scoped>
.back_arrow {
  position: absolute;
  left: 24px;
  top: 24px;
  cursor: pointer;
  z-index: 10;
}

.back_arrow_v2 {
  position: absolute;
  left: 24px;
  top: 24px;
  cursor: pointer;
  z-index: 10;
}

.modal_head {
  text-align: start;
  margin-left: 46px;
  margin-bottom: 24px; /* Добавлен отступ снизу */
  font-size: 18px;
  color: #fff;
  font-weight: 500;
}

.modal_flow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px 0;
  border-top: 1px solid #ffffff32;
  border-bottom: 1px solid #ffffff32;
  margin-bottom: 24px; /* Добавлен отступ снизу */
}

.modal_flow_element {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}

.modal_flow_element_num {
  background: #888888;
  border-radius: 50%;
  padding: 7px;
  width: 31px;
  height: 31px;
  aspect-ratio: 1/1;
  border: 1px solid transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 500;
  transition: all 0.3s;
}

.modal_flow_element_num:hover {
  opacity: 0.9;
  transform: scale(1.05);
}

.num_active {
  background: #8A75FF;
  border: 1px solid #fff;
}

.num_complite {
  background: #8A75FF;
  border: 1px solid transparent;
  padding: 3px;
}

.num_complite svg {
  width: 24px;
  height: 24px;
}

.num_errore {
  background: #FF3A99;
  border: 1px solid #fff;
}

.modal_flow_element_text {
  font-size: 14px;
  color: #fff;
  white-space: nowrap;
}

/* Медиа-запросы из оригинального компонента */
@media (max-width: 1024px) {
  .modal_flow {
    display: none;
  }
  
  .modal_head {
    font-size: 16px;
    margin-left: 40px;
    margin-bottom: 16px;
  }
}

@media (max-width: 768px) {
  .back_arrow,
  .back_arrow_v2 {
    left: 16px;
    top: 16px;
  }
  
  .back_arrow svg,
  .back_arrow_v2 svg {
    width: 30px;
    height: 12px;
  }
  
  .modal_head {
    margin-left: 35px;
    font-size: 14px;
    margin-bottom: 12px;
  }
}

@media (max-width: 480px) {
  .back_arrow,
  .back_arrow_v2 {
    left: 12px;
    top: 12px;
  }
  
  .back_arrow svg,
  .back_arrow_v2 svg {
    width: 24px;
    height: 10px;
  }
  
  .modal_head {
    margin-left: 30px;
    font-size: 12px;
    margin-bottom: 10px;
  }
}
</style>